module.exports = __webpack_public_path__ + "img/3.f8c3c90b.png";